// This file contains getters for AB test group values. Functions should be removed from here as AB tests finish.

import { getABTestGroup } from './shared/getABTestGroup';

export function getEnterFlowProgressValue() {
  return 'VARIANT1';
}

export function getHomePageHeroTextSep2025Value() {
  return getABTestGroup('HomePageHeroTextSep2025');
}

export function getDashboard2026Value() {
  return getABTestGroup('Dashboard2026');
}

export function getChooseYourPlanBoostValue() {
  return getABTestGroup('ChooseYourPlanBoost');
}

export function getFirstEntryVsFirstOrder50Off2026Value() {
  return getABTestGroup('FirstEntryVsFirstOrder50Off2026');
}

export function getHomePage2026Value() {
  return getABTestGroup('HomePage2026');
}

export function getSkipChooseYourPlan2026Value() {
  return getABTestGroup('SkipChooseYourPlan2026');
}
